// extracted by mini-css-extract-plugin
module.exports = {"BpmnModelsList":"BpmnModelsList_BpmnModelsList__10wch"};